import { makeStyles } from 'tss-react/mui';
import {
  accordionSummaryClasses,
  buttonBaseClasses,
  svgIconClasses,
} from '@mui/material';

interface IAccordionNavButtonProps {
  isLightTheme: boolean;
  isMobileSideBar: boolean;
}

export const useAccordionNavButtonStyles = makeStyles<
  IAccordionNavButtonProps,
  'mainButton'
>({
  name: 'AccordionNavButton',
})((theme, { isLightTheme, isMobileSideBar }, classes) => ({
  root: {
    backgroundImage: 'none',
  },
  commonButton: {
    width: '100%',
    color: theme.palette.grey[600],
    justifyContent: 'flex-start',
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.default,
      boxShadow: 'none',
    },

    [theme.breakpoints.down('sm')]: {
      color: theme.palette.text.secondary,
      '&:after': {
        content: '""',
        display: isMobileSideBar ? 'none' : 'flex',
        position: 'absolute',
        background: theme.palette.background.default,
        height: 2,
        bottom: 0,
        left: 45,
        width: 'calc(90% - 45px)',
      },
    },
  },
  mainButton: {
    height: 48,
    padding: theme.spacing(3),
    fontWeight: 400,
    gap: theme.spacing(3),

    [`&& .${svgIconClasses.root}`]: {
      strokeWidth: 1.5,
    },

    [theme.breakpoints.down('sm')]: {
      position: 'relative',
    },
    [`&.Mui-disabled`]: {
      '&&': {
        backgroundColor: 'transparent',
        color: theme.palette.grey[400],
        fontWeight: 400,
        '& svg': {
          color: 'inherit',
          backgroundColor: 'inherit',
        },
      },
    },
  },
  disabled: {
    '&&': {
      cursor: 'default',
      color: theme.palette.grey[isLightTheme ? 400 : 700],
      backgroundColor: 'transparent',
      fontWeight: 400,
    },
  },
  activeLink: {
    '&&': {
      cursor: 'default',
      fontWeight: 600,
      background: theme.palette.background.default,
      color: theme.palette.primary.main,

      '&& svg': {
        strokeWidth: 2,
        strokeLinejoin: 'round',
        color: theme.palette.primary.main,
      },

      [`.${buttonBaseClasses.root}`]: {
        color: theme.palette.primary.main,
      },
    },
  },
  ordinaryButton: {
    color: theme.palette.text.secondary,
  },
  summaryRoot: {
    padding: 0,
    borderRadius: 12,

    '&:hover': {
      [`& .${classes.mainButton}`]: {
        color: theme.palette.primary.main,
      },

      backgroundColor: theme.palette.background.default,
      boxShadow: 'none',

      [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
        '& svg': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  summaryContent: {
    margin: 0,
  },
  summaryExpanded: {
    '&&': {
      minHeight: 'unset',
      margin: 0,

      [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
        transform: 'rotate(90deg)',
      },
    },
  },
  detailsRoot: {
    margin: theme.spacing(3, 0, 0, 6),
    padding: theme.spacing(0, 0, 0, 3),
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  innerButton: {},
}));
